import { computeColor as y, textColors as mt, shadowBackgroundColors as ht, backgroundColors as K, isColorGradient as j, textColorsFallback as O, isHexColor as Q } from "@typedream/core";
import u from "classnames";
import { useState as D, useRef as ft, useEffect as gt } from "react";
import { alignTypeToJustifyContent as ut } from "../utils/layout.js";
import { getWidthStyle as V } from "../utils/sizing.js";
import { useAnimatedBlock as bt } from "../utils/useAnimatedBlock.js";
import { buttonElement as pt, button as X, themeableButton as Z, glowingButton as xt, rotatingShadow as wt, glowWrapper as $t, rotatingBorder as vt, rotateAnimationCircle as tt, rotateAnimationBorder as yt, wrapper as Bt, wrapperBackground as kt, content as Et, icon as et, iconWithEmptyText as nt, smallRotateAnimation as Nt, rotateAnimation as Tt } from "./Button.css.js";
import { jsx as o, jsxs as U } from "react/jsx-runtime";
import { Link as _t } from "../link/Link.js";
import { Icon as At } from "../icon/Icon.js";
const R = {
  margin: "0px 0px 0px 0px",
  borderRadius: "999px 999px 999px 999px",
  boxShadow: "0 10px 20px -10px #6E79D6"
}, Ct = {
  regular: "bx",
  solid: "bxs",
  logo: "bxl"
};
function z({
  icon: e,
  className: a,
  onClick: s
}) {
  if (!e)
    return null;
  switch (e.type) {
    case "icon":
      return /* @__PURE__ */ o("div", {
        contentEditable: !1,
        className: a,
        style: {
          color: y(e.content.color, mt)
        },
        role: "none",
        onClick: s,
        children: /* @__PURE__ */ o(At, {
          type: Ct[e.content.type],
          name: e.content.name
        })
      });
    case "emoji":
      return /* @__PURE__ */ o("div", {
        contentEditable: !1,
        className: a,
        role: "none",
        onClick: s,
        children: e.content
      });
    case "image":
      return /* @__PURE__ */ o("div", {
        contentEditable: !1,
        className: a,
        role: "none",
        onClick: s,
        children: /* @__PURE__ */ o("img", {
          src: e.content,
          alt: "button icon"
        })
      });
    default:
      return null;
  }
}
z.defaultProps = {
  className: void 0,
  onClick: void 0
};
function J(e) {
  const {
    element: a,
    children: s,
    attributes: x,
    className: B
  } = e, {
    mobile_hide: k,
    desktop_hide: A,
    width: E,
    width_max: C,
    align: l,
    animation: I,
    margin: b,
    border_radius: w,
    box_shadow: N
  } = a, [L, F, $, M] = (b != null ? b : R.margin).toString().split(" "), [d, G] = bt(I);
  return /* @__PURE__ */ o("div", {
    ref: d,
    className: u(B, {
      "mobile:hidden": k,
      "desktop:hidden": A
    }, G, pt),
    style: {
      "--width": V(E, C).width,
      "--max-width": V(E, C).maxWidth,
      "--horizontal-alignment": l && ut(l),
      "--margin-top": L,
      "--margin-right": F,
      "--margin-bottom": $,
      "--margin-left": M,
      "--margin": b != null ? b : R.margin,
      "--border-radius": w != null ? w : R.borderRadius,
      "--box-shadow": N != null ? N : R.boxShadow
    },
    ...x,
    children: s
  });
}
J.defaultProps = {
  width_max: void 0,
  align: void 0,
  animation: void 0
};
function Y(e) {
  var L, F;
  const {
    element: a,
    children: s,
    onClickIcon: x,
    editable: B
  } = e, {
    buttonType: k,
    background: A,
    color: E,
    icon: C,
    customAttributes: l,
    variant: I,
    style: b,
    glowing_background: w
  } = a;
  y(A, ht);
  const N = ((F = (L = a == null ? void 0 : a.children) == null ? void 0 : L[0]) == null ? void 0 : F.text) === "";
  if (b === "glowing_button") {
    const [$, M] = D(!1), [d, G] = D(0), [p, ot] = D(0), rt = w === "white" ? "#1b1b1b" : "#fff", it = w === "white" ? "linear-gradient(180deg, #FFF, #EBEBEB)" : "linear-gradient(180deg, #484848, #1A1A1A)", at = $ ? "#fff" : rt, W = ft(null), v = y(A, K), q = v && j(v);
    gt(() => {
      if (W.current) {
        const t = W.current.offsetWidth, m = W.current.offsetHeight;
        G(t), ot(m);
      }
    }, [s]);
    const P = (t, m) => {
      if (!t)
        return t;
      if (j(t)) {
        const c = t.match(/#[0-9a-fA-F]{6}/g);
        if (c) {
          const h = c.map((n) => {
            const r = n.match(/\w\w/g);
            if (!r)
              return t;
            const [f, g, T] = r.map((_) => parseInt(_, 16));
            return `rgba(${f},${g},${T},${m})`;
          });
          let i = t;
          for (let n = 0; n < c.length; n += 1)
            i = i.replace(c[n], h[n]);
          return i;
        }
      }
      if (Q(t)) {
        const c = t.match(/\w\w/g);
        if (!c)
          return t;
        const [h, i, n] = c.map((r) => parseInt(r, 16));
        return `rgba(${h},${i},${n},${m})`;
      }
      return t;
    }, st = (t) => {
      if (!t)
        return t;
      if (j(t)) {
        const m = t.match(/#[0-9a-fA-F]{6}/g);
        if (m)
          return m[0];
      }
      return t;
    }, ct = (t, m, c) => {
      const h = t / 255, i = m / 255, n = c / 255, r = Math.max(h, i, n), f = Math.min(h, i, n);
      let g = 0, T = 0;
      const _ = (r + f) / 2;
      if (r !== f) {
        const S = r - f;
        T = _ > 0.5 ? S / (2 - r - f) : S / (r + f), r === h ? g = (i - n) / S + (i < n ? 6 : 0) : r === i ? g = (n - h) / S + 2 : r === n && (g = (h - i) / S + 4), g /= 6;
      }
      return [g * 360, T * 100, _ * 100];
    }, lt = (t, m) => {
      if (!t)
        return t;
      if (Q(t)) {
        const c = t.match(/\w\w/g);
        if (!c)
          return t;
        const [h, i, n] = c.map((_) => parseInt(_, 16)), [r, f, g] = ct(h, i, n), T = Math.min(g + (m || 0), 100);
        return `hsl(${r}, ${f}%, ${T}%)`;
      }
      return t;
    }, dt = () => d < 55 ? tt : d < 110 ? Nt : Tt, H = q ? st(v) : lt(v, 10);
    return /* @__PURE__ */ U("button", {
      ref: W,
      ...l,
      className: u(X, Z({
        variant: I
      }), l == null ? void 0 : l.className, xt),
      onMouseEnter: () => M(!0),
      onMouseLeave: () => M(!1),
      style: {
        background: $ ? P(v, 0.7) : it
      },
      type: k || "button",
      children: [/* @__PURE__ */ o("div", {
        className: u(wt, dt()),
        style: {
          width: p - 2,
          height: p - 2,
          "--half-width": `${d / 100}`,
          "--start-position": "2px",
          "--mid-top-position": `${d / 2}px`,
          "--mid-bottom-position": `${d / 2 - p}px`,
          "--end-position": `${d - p}px`,
          boxShadow: `0 -5px 12px -5px ${P(H, 0.7)}, 0 -7px 22px -10px ${P(H, 0.7)}`
        }
      }), /* @__PURE__ */ o("div", {
        className: $t,
        children: /* @__PURE__ */ o("div", {
          className: u(vt, d < 55 ? tt : yt),
          style: {
            width: p,
            height: p + 5,
            background: `conic-gradient(${H} 0%, transparent 15.5%, transparent 87%, ${H} 98%)`,
            "--button-width": `${d - p}px`,
            "--width-multiplier": `${d / p}`
          }
        })
      }), /* @__PURE__ */ o("div", {
        className: u(Bt, kt({
          glowing_background: w
        })),
        style: {
          background: $ && (q ? v : `radial-gradient(circle at 50% 300%, white, ${v})`),
          color: $ && y(E, O)
        }
      }), /* @__PURE__ */ U("div", {
        className: u(Et),
        style: {
          color: $ ? at : y(E, O)
        },
        children: [/* @__PURE__ */ o(z, {
          icon: C,
          className: u(et, {
            [nt]: B && N
          }),
          onClick: x
        }), s]
      })]
    });
  }
  return /* @__PURE__ */ U("button", {
    ...l,
    className: u(X, Z({
      variant: I
    }), l == null ? void 0 : l.className),
    style: {
      background: y(A, K),
      color: y(E, O)
    },
    type: k || "button",
    children: [/* @__PURE__ */ o(z, {
      icon: C,
      className: u(et, {
        [nt]: B && N
      }),
      onClick: x
    }), s]
  });
}
Y.defaultProps = {
  background: void 0,
  color: void 0,
  shadowColor: void 0
};
function jt(e) {
  const {
    element: a,
    children: s
  } = e, {
    url: x,
    open_in_new_tab: B,
    internal_link: k
  } = a;
  return x ? /* @__PURE__ */ o(J, {
    ...e,
    children: /* @__PURE__ */ o(_t, {
      href: x,
      internal_link: k,
      open_in_new_tab: B,
      children: /* @__PURE__ */ o(Y, {
        ...e,
        children: s
      })
    })
  }) : /* @__PURE__ */ o(J, {
    ...e,
    children: /* @__PURE__ */ o(Y, {
      ...e,
      children: s
    })
  });
}
export {
  R as BUTTON_DEFAULTS,
  jt as ButtonElement,
  z as ButtonIcon
};
